import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * GroupCategoryApi API
 */
class GroupCategoryApi extends ApiBase {
  /**
   * create groupCategories
   * @param {*} groupCategories
   */
  async create(groupCategories) {
    const request = {
      url: `${this.API_URL}/groupcategories`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(groupCategories)
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new GroupCategoryApi();
